var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.getComponent(_vm.field),_vm._b({tag:"component",attrs:{"read-only":""}},'component',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }